import React, { Component } from 'react';
import Autocomplete from '../common/autocomplete';
import strings from '../locales/';
import DynamicListInput from '../common/forms/dynamicListInput';

const SecondHeader = props =>
  !props.loadingFilter ? (
    <div className="second-header">
      <div className="box-form islabel box170 inner-dashboard-input">
        <div>
          <label>{"Tipo de vehículo"}</label>
        </div>
        <div>
          <DynamicListInput
            id="vehicleType"
            dataUpdate="vehicleType"
            value={props.filters.vehicleType ? props.filters.vehicleType : ""}
            list={props.lists["VEHICLE TYPE"]}
            className="modal-input"
            onClickHandler={props.handleSubmit}
            emptyValue={"Todas"}
          />    
        </div>
      </div>
      <div className="box-form islabel box170 inner-dashboard-input">
        <div>
          <label>{"Sentido"}</label>
        </div>
        <div>
          <DynamicListInput
            id="direction"
            dataUpdate="direction"
            value={props.filters.direction ? props.filters.direction : ""}
            list={props.lists["DIRECTION"]}
            className="modal-input"
            onClickHandler={props.handleSubmit}
            emptyValue={"Todas"}
          />  
        </div>
      </div>
      <div className="box-form islabel box170 inner-dashboard-input">
        <div>
          <label>{"Estatus"}</label>
        </div>
        <div>
          <DynamicListInput
            id="status"
            dataUpdate="status"
            value={props.filters.status ? props.filters.status : ""}
            list={{
              items: [
                {name:"Realizado",state:true},
                {name:"Planificado",state:true}
              ]
            }}
            className="modal-input"
            onClickHandler={props.handleSubmit}
            emptyValue={"Todas"}
          />  
        </div>
      </div>
      <div className={"box-form box-form-button"}>
        <div className={'normal_button'} onClick={props.exportExcel}>
          <div>{"Exportar a Excel"}</div>
        </div>
      </div>
      <div className={"box-form box-form-button"}>
        <div className={'normal_button'} onClick={props.exportExcelCharts}>
          <div>{"Exportar a Gráficos a Excel"}</div>
        </div>
      </div>
    </div>
  ) : (
    <div className="second-header" />
  );

export default SecondHeader;



// WEBPACK FOOTER //
// ./source/client/components/flow_admin_rca_reports/secondHeader.jsx